module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Gb-Da-Eb.bf334d6a.png";